import { XCircleIcon } from '@heroicons/react/24/outline';
import { FC, ReactElement } from 'react';
export interface IBucketTagProps {
    title: string;
    icon?: ReactElement;
    onRemove: () => void;
}

export const BucketTag: FC<IBucketTagProps> = ({ title, icon, onRemove }) => {
    return (
        <div className="min-h-9 items-center mr-1 mb-1 bg-primary-300 text-slate-50 dark:bg-primary-700 dark:text-slate-300 rounded-md pl-3 dark:text-primary hidden md:flex">
            <div className="mr-2 min-w-5">{icon}</div>
            <div className="text-md pr-2">{title}</div>
            <div className="cursor-pointer hover:text-red-500" onClick={onRemove}>
                <XCircleIcon
                    className="text-slate-100 dark:text-slate-200 mr-2 h-5 w-5 hover:text-lavender-dark dark:hover:text-white transition-all"
                    strokeWidth="2"
                />
            </div>
        </div>
    );
};
